import { CheckboxGroup, Loading, TextSpan } from "@dgs/core";
import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { IndustryOptionResource } from "../../types/industry";
import { IndustryMultiSelectField } from "../../ui/IndustryMultiSelectField";
import { FilterAccordionBody, FilterAccordionItem, FilterCheckbox } from "./AccordionFilterItemStyles";
import { useEventFilterAccordionItems } from "./EventFilterAccordionItemsProvider";

interface Props {
	name: string;
}

export const AccordionItemIndustry: FC<Props> = ({ name }) => {
	const { t } = useTranslation();
	const [{ value }, , { setValue }] = useField<IndustryOptionResource[]>(name);
	const { industries, industriesIsLoading, renderIndustriesAsCheckboxes } = useEventFilterAccordionItems();

	if (!industries || !industries.length) {
		return null;
	}

	const renderBody = () => {
		if (industriesIsLoading) return <Loading />;
		if (renderIndustriesAsCheckboxes) {
			return (
				<CheckboxGroup name={name}>
					{industries.map((industry) => (
						<FilterCheckbox
							key={`${industry.id}`}
							name={`industry-${industry.id}`}
							value={value.some((v) => v.id === industry.id)}
							label={industry.name}
							onChange={(e) =>
								setValue(e.target.value ? [...value, industry] : value.filter((v) => v.id !== industry.id))
							}
						/>
					))}
				</CheckboxGroup>
			);
		}
		return <IndustryMultiSelectField name={name} label="" />;
	};

	return (
		<FilterAccordionItem
			title={t("Industry")}
			actions={<TextSpan $size="small">{t("IN_RELATION")}</TextSpan>}
			initialOpen={value && value.length > 0}
			body={<FilterAccordionBody>{renderBody()}</FilterAccordionBody>}
		/>
	);
};
